import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export default function About() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <section ref={ref} className="relative py-32 px-6 bg-dark-800">
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="font-serif text-5xl md:text-6xl text-gold-400 mb-8">
            Sobre la Experiencia
          </h2>
          
          <div className="space-y-6 text-lg md:text-xl text-warm-200 leading-relaxed">
            <p className="font-sans">
              <strong className="text-gold-400 font-serif text-2xl">El Cuaderno de La Magdalena</strong> es una peregrinación interior de 40 días inspirada en la vida de María Magdalena.
            </p>
            
            <p className="font-sans">
              Una experiencia personal, construida día a día, con <strong className="text-warm-100">oración, reflexión, escritura espiritual</strong> y <strong className="text-warm-100">acciones concretas de fe</strong>.
            </p>
            
            <motion.p
              initial={{ opacity: 0, scale: 0.95 }}
              animate={inView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.8, delay: 0.3 }}
              className="font-serif text-3xl md:text-4xl text-gold-300 italic mt-12 pt-8 border-t border-gold-500/30"
            >
              No es un devocional más.
              <br />
              <span className="text-warm-100">Es un camino de transformación.</span>
            </motion.p>
          </div>
        </motion.div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-32 h-32 border border-gold-500/20 rounded-full"></div>
      <div className="absolute bottom-20 right-10 w-40 h-40 border border-gold-500/20 rounded-full"></div>
    </section>
  );
}